import { useDesignSystem } from 'contexts/design-system'
import AdvancedComboBoxEui from './advancedComboBox.eui'
import AdvancedComboBoxMui from './advancedComboBox.mui'
import { AdvancedComboBoxProps } from 'components/ComboBox/types'

export type { AdvancedComboBoxProps } from 'components/ComboBox/types'

/**
 * Combo box whose options show a name plus secondary detail. Renders the EUI or
 * MUI presentation based on the host form's design system
 * (`DesignSystemProvider`, default `'eui'`) at identical prop parity.
 */
export default function AdvancedComboBox<T>( props: AdvancedComboBoxProps<T> ) {
	return useDesignSystem() === 'mui'
		? <AdvancedComboBoxMui {...props} />
		: <AdvancedComboBoxEui {...props} />
}
